import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../../css/home.css';
import ApiService from '../../../../services/api';
import img6 from '../../../../media/courses_hero.jpg';
import Timer from '../../../../media/timer_3.png';

const CoursesGrid = () => {
  const [courses, setCourses] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const categoriesRef = useRef(null);

  const [maskState, setMaskState] = useState("start");

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    fetchCourses();
  }, [selectedCategory]);

  useEffect(() => {
    const list = categoriesRef.current;
    if (!list) return;

    const updateMask = () => {
      const canScroll = list.scrollWidth > list.clientWidth + 2;

      if (!canScroll) {
        setMaskState("none");
        return;
      }

      const start = list.scrollLeft <= 2;
      const end =
        list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;

      if (start) setMaskState("start");
      else if (end) setMaskState("end");
      else setMaskState("middle");
    };

    updateMask();

    list.addEventListener("scroll", updateMask);

    window.addEventListener("resize", updateMask);

    return () => {
      list.removeEventListener("scroll", updateMask);
      window.removeEventListener("resize", updateMask);
    };

  }, [categories]);

  const fetchCourses = async () => {
    setIsLoading(true);
    try {
      const data = await ApiService.selectedCourses(selectedCategory);
      setCourses(data);
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await ApiService.getCategories();
      setCategories(response);
    } catch (error) {
      console.error('Errore nel caricamento delle categorie:', error);
    }

  };

  const renderStars = (rating, clickable = false) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      let starClass = "empty";
      if (i <= rating) {
        starClass = "filled";
      } else if (i - rating <= 0.5) {
        starClass = "half";
      }
      stars.push(
        <span
          key={i}
          className={`star ${starClass} ${clickable ? "clickable" : "disabled"}`}
        >
          ★
        </span>
      );
    }
    return stars;
  };

  const scrollCategories = (direction) => {
    const container = categoriesRef.current;

    if (!container) return;

    const scrollAmount = container.clientWidth * 0.7;

    container.scrollBy({
      left: direction * scrollAmount,
      behavior: "smooth"
    });
  };

  return (

    <div className="courses-section">

      <div className="target-audience-section">
        <h2 className="target-title">La Nostra Offerta Formativa</h2>
        <p className="target-description">
        Impara, sperimenta e metti subito in pratica ciò che studi, attraverso contenuti chiari e orientati ai risultati. 
        I nostri corsi ti guidano passo dopo passo verso i tuoi obiettivi, aiutandoti a sviluppare competenze concrete e realmente spendibili nel mondo del lavoro.
        </p>

        <div className="categories-wrapper">

        {maskState !== "none" && maskState !== "start" && (
          <button 
            className="category-arrow left"
            onClick={() => scrollCategories(-1)}
          >
            ‹
          </button>
        )}
          <div ref={categoriesRef}
                className={`courses-hero-categories ${maskState}`}>
            <button
              className={`courses-category ${selectedCategory === null ? 'active' : ''}`}
              onClick={() => setSelectedCategory(null)}
            >
              Tutti
            </button>

            {categories.map(cat => (
              <button
                key={cat.name}
                className={`courses-category ${selectedCategory === cat.name ? 'active' : ''}`}
                onClick={() => setSelectedCategory(cat.name)}
              >
                {cat.name}
              </button>
            ))}
          </div>
        {maskState !== "none" && maskState !== "end" && (
          <button 
            className="category-arrow right"
            onClick={() => scrollCategories(1)}
          >
            ›
          </button>
        )}
        </div>
      </div>

      
      {!isLoading && ( 
        <div className="highlighted-courses-grid">
          {courses.map(course => {
            const avgRating = course.avg_rating ? course.avg_rating / 2 : 0; 
            const totalReviews = course.total_reviews || 0;

            return(
              <Link style={{ textDecoration: 'none' }} to={`/course/${course.slug}`}>
              <div key={course.slug} className="highlighted-course-card">
                <div className="course-image-wrapper">
                  <img src={course.main_img} alt={course.title} className="highlighted-course-image" />
                </div>

                <div className="highlighted-course-info">
                  <h3 className="highlighted-course-title">{course.title}</h3>
                  <p className="highlighted-course-description">
                    <img style={{width:"24px", height:"24px", marginTop:"-5px" ,marginRight: "10px"}} src={Timer} alt="" />
                    {course.my_total_duration
                    ? `${course.my_total_duration} ${
                        course.my_total_duration === 1 ? "ora" : "ore"
                      }`
                    : course.total_duration
                      ? course.total_duration < 60
                        ? `${course.total_duration} min`
                        : `${Math.floor(course.total_duration / 60)} ${
                            Math.floor(course.total_duration / 60) === 1 ? "ora" : "ore"
                          }`
                      : "0 min"}
                  </p>

                  <div className="highlighted-course-footer">
                    <div className="highlighted-rating">
                      {renderStars(avgRating)}
                      <span className="reviews">({totalReviews})</span>
                    </div>
                    <Link style={{ textDecoration: 'none' }} to={`/course/${course.slug}`}>
                    <button className="highlighted-button">Dettagli</button>
                    </Link>
                  </div>
                </div>
              </div>
              </Link>
            );
            })}
          </div>
        
      )}
    

      {isLoading}

    </div>
     
  );
};

export default CoursesGrid;